import { render, staticRenderFns } from "./StepBox.vue?vue&type=template&id=6b211c20&"
import script from "./StepBox.vue?vue&type=script&lang=js&"
export * from "./StepBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports